__turbopack_context__.v({
  "bespoke": "AuthUI-module__1Esz1a__bespoke",
  "otp": "AuthUI-module__1Esz1a__otp",
});
